// extracted by mini-css-extract-plugin
export var popper = "_9x-0";